import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Loader } from 'goustouicomponents'
import css from './ContentLoader.module.css'

const ContentLoader = ({ inJobCard }) => (
  <div
    className={classnames(css.wrapper, {
      [css.jobCard]: inJobCard,
    })}
  >
    <Loader color="Bluecheese" />
  </div>
)

ContentLoader.propTypes = {
  inJobCard: PropTypes.bool,
}

ContentLoader.defaultProps = {
  inJobCard: false,
}

export { ContentLoader }
